export const DotStatus: React.FC<{
  active: boolean;
}> = ({ active }) => {
  const color = active ? "bg-green-500" : "bg-gray-300";

  return <div className={`${color} w-[6px] h-[6px] rounded-[50%] mr-2`} />;
};
